export class debouncer {

    func: Function = () => { };
    timer?: number = undefined;
    timeout = 300;
    bindTo: any;
    currentArgs: any[] = [];

    constructor(func: Function, timeout = 300, bind: any = undefined) {
        this.func = func;
        this.timeout = timeout;
        this.bindTo = bind || this;
    }

    // Call this method instead of the function you want to debounce
    debounce = (...args: any[]) => {
        clearTimeout(this.timer);
        this.currentArgs = args;
        this.timer = window.setTimeout(() => {
            this.func.apply(this.bindTo, args);
            this.timer = undefined;
        }, this.timeout);
    };

    // Immediately execute the function and clear the timer
    flush = () => {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = undefined;
            this.func.apply(this.bindTo, this.currentArgs);
        }
    }

    // Clear the timer without executing the function
    clear = () => {
        if (this.timer !== undefined) {
            clearTimeout(this.timer);
            this.timer = undefined;
        }
    }    
}